let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
    scrollTopButton = document.querySelector(".scroll-top");

function smoothScroll(){
  let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
  if (currentScroll > 0) {
    window.requestAnimationFrame(smoothScroll);
    window.scrollTo(0, currentScroll - (currentScroll / 5));
  }
}

if (scrollTopButton) {
  scrollTopButton.addEventListener("click", ()=> {
    smoothScroll();
  });

  window.addEventListener("scroll", ()=> {
    if (document.body.scrollTop > windowHeight * 2 || document.documentElement.scrollTop > windowHeight * 2) {
      scrollTopButton.classList.add("scroll-top--show");
    } else {
      scrollTopButton.classList.remove("scroll-top--show");
    }
  });
}
